import { createSvgIcon } from "@mui/material";

// If the icon changes, update both the string and the JSX below.
export const MY_PRODUCT_SVG = [
    '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">',
    '<path d="M6 12H18M12 6V18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
    '</svg>',
].join('');

export const MyProductIcon = createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M6 12H18M12 6V18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>,
    'MyProductIcon'
)